import MatchHeight from 'vanilla-js-match-height'

export default function Heights() {
	new MatchHeight('.js-product-name')
	new MatchHeight('.js-product-price')
	new MatchHeight('.js-product-card')
	new MatchHeight('.js-post-heading')
	new MatchHeight('.js-banner-heading')
	new MatchHeight('.js-banner-content')
	new MatchHeight('.js-card-title')
	new MatchHeight('.js-card-content')
	new MatchHeight('.js-card-button')
}
